<template>
  <div class="wrapper">
    <p class="title text-center">Edit Password</p>
    <div class="content">
      <div class="new-password-wrapper">
        <div class="new-password text-center">
          <div class="text-message text-center">Please enter your new password below.</div>
        </div>
        <div class="from-inputs">
          <div class="m-d-gruop" :class="{'invalid-value' : invalidPassword}">
            <b-form-input maxLength="20" v-model="password" id="password" type="password" required @input="changePassword"/>
            <label>Password</label>
          </div>
        </div>
        
        <span @click="showPasswordVal()" class="showPassword">
          <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0C5.18182 0 1.49409 2.69533 0 6.5C1.49409 10.3047 5.18182 13 9.5 13C13.8182 13 17.5059 10.3047 19 6.5C17.5059 2.69533 13.8182 0 9.5 0ZM9.5 10.8332C7.11636 10.8332 5.18182 8.89184 5.18182 6.49984C5.18182 4.10784 7.11636 2.1665 9.5 2.1665C11.8836 2.1665 13.8182 4.10784 13.8182 6.49984C13.8182 8.89184 11.8836 10.8332 9.5 10.8332ZM6.90909 6.4999C6.90909 5.06124 8.06636 3.8999 9.5 3.8999C10.9336 3.8999 12.0909 5.06124 12.0909 6.4999C12.0909 7.93857 10.9336 9.0999 9.5 9.0999C8.06636 9.0999 6.90909 7.93857 6.90909 6.4999Z" :fill="colorVal"/>
          </svg>
        </span>
        <div class="err-wrapper">
          <div class="current-password" v-if="invalidPassword">
            <p class="error-value text-hint password-hint-error">
              Password must contain 8-20 characters, a lowercase letter, an uppercase letter, a number and a special character.
            </p>
          </div>
        </div>
        <p v-if="!invalidPassword" class="text-hint password-hint">
          <b>Note:</b> <span class="normal-hint">Password must contain 8-20 characters, a lowercase letter, an uppercase letter, a number and a special character.</span>
        </p>
      </div>

    </div>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button class="submit-btn btn btn-primary" size="md" @click="onSubmit" :disabled=" disableBtn || getLoading || !password || invalidPassword">
        <i v-if="getLoading" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"></i>
        <span v-else>Save</span>
      </button>
      <button class="btn btn-outline-danger" @click="updatePWD">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
// import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["loggedInUser"],
  data() {
    return {
      submitted: false,
      colorVal: '#787878',
      password: "",
      invalidPassword:false,
      passwordHasError: false,
      passwordRegex : /(?=^.{8,}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
    };
  },
  computed: {
    ...mapGetters("user", ["getLoading", "getModalState", "getUserData"]),
    ...mapGetters("modal", ["getModalInfo"]),
    disableBtn() {
      // let invalid = false;
      // this.passwordHasError = false;
      // if(!this.$v.password.minLength || !this.$v.password.maxLength || !this.$v.password.containsUppercase
      // || !this.$v.password.containsLowercase || !this.$v.password.containsNumber || !this.$v.password.containsSpecial){
      //   this.passwordHasError = true;
      //   invalid = true;
      // }
      return (
        this.password.length < 8 || this.password.length > 20
      )
    }
  },
  // validations: {
  //   password: {
  //     required,
  //     minLength: minLength(8),
  //     maxLength: maxLength(20),
  //     containsUppercase: function(value) {
  //       return /[A-Z]/.test(value);
  //     },
  //     containsLowercase: function(value) {
  //       return/[a-z]/.test(value);
  //     },
  //     containsNumber: function(value) {
  //       return  /[0-9]/.test(value);
  //     },
  //     containsSpecial: function(value) {
  //       return /[#?!@$%^&*-]/.test(value);
  //     },
  //   },
  // },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("userPassword");
    },
  },
  methods: {
    ...mapActions("user", ["changeUserPasswordAction", "resetState", "setTmpPwdFlag"]),
    changePassword(){
      this.invalidPassword = false;
      this.submitted = false;
    },
    onSubmit() {
      this.invalidPassword = false;
      this.submitted = true;
      if(this.password && !this.passwordRegex.test(this.password)){
        this.invalidPassword = true;
      }else{
        this.changeUserPasswordAction({
          password: this.password,
          id : this.getUserData.id,
        });
      }
    },
    showPasswordVal(){
      const passwordField = document.getElementById('password');
      if (passwordField.type === "password") {
          passwordField.type = "text";
          this.colorVal = '#103F5E'
      } else {
          passwordField.type = "password";
          this.colorVal = '#787878'
      }
    },
    updatePWD(){
      // const {id} = this.getUserData;
      this.$bvModal.hide('userPassword');
      this.setTmpPwdFlag(0);
    }
  },
  beforeMount() {
    this.resetState();
  },
};
</script>

<style lang="scss">
div#userPassword___BV_modal_content_ {

  .wrapper {
    .text-title {
      font-size: 20px;
      margin-bottom: 30px;
      text-align: center;
      color: rgba(96, 96, 96, 0.87);
      opacity: 0.8;
      font-weight: normal;
    }
    .form-group{
      margin-bottom: 0px;
    }
    .input-wrapper {
      padding: 0 34px !important;
      position: relative;
    }

    .current-password-wrapper {
      margin-bottom: 44px;
    }
    .h-line {
      margin: 0 !important;
      margin-top: 40px !important;
      margin-bottom: 24px !important;
    }
    .new-password-wrapper {
      margin-bottom: 9px;
    }
    .text-hint {
      font-size: 14px;
      color: #787878;
      text-align: center;
      margin-bottom: 33px;
    }
    .password-hint {
      margin-left: 20px;
      width:376px;
      text-align: left;
      line-height: 22px;
      letter-spacing: 0.25px;
      color: #787878;
      font-family: Lato;
      font-size: 14px;
      .normal-hint{
        font-weight: 400;    
      }
    }

    .password-hint-error{
      width:370px;
      margin-top: 8px;
      margin-left: 20px;
      font-family: Lato;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      letter-spacing: 0.25px;
      text-align: left;
      color: #F46A6A;

    }
    @media (max-width: 768px){ 
        .input-wrapper{
          padding: 0 !important;
        .password-eye{
        right: 25px;
      }
        }
        .password-hint{
          margin-left: 20px;
        }
    }
  }

  .m-d-gruop > input {
    width: 90%;
  }
  .mt-71{
    margin-top:-71px
  }

  .err-wrapper {
    padding-left: 0px;
  }

  .current-password{
    margin-top: 0px!important;
  }

  .text-message{
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #4A4A4A;
  }

  .new-password{
    margin-bottom:40px;
  }



  .fw-700{
    font-weight: 700 !important;
  }
}
</style>
